import React from "react";
import * as Icons from "components/Icons";

export default function Icon({ name, className }) {
  const DynamicComponent = Icons[name];
  return <DynamicComponent className={className} />;
}
